import { useCallback, useEffect, useState } from "react";
import { Blog, BlogService } from "../client/api";

type UseNewsParams = {
  areaOfInterestId: number | undefined;
  limit?: number;
  offset?: number;
};

type UseNewsResult = {
  news: Blog[];
  loading: boolean;
  error: Error | null;
  refetch: () => void;
};

export function useNews({
  areaOfInterestId,
  limit = 5,
  offset = 0,
}: UseNewsParams): UseNewsResult {
  const [news, setNews] = useState<Blog[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchNews = useCallback(async () => {
    if (!areaOfInterestId) {
      setNews([]);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const result = await BlogService.getBlogsBlogGet(limit, offset, areaOfInterestId);
      setNews(result || []);
    } catch (err) {
      setError(err instanceof Error ? err : new Error("Failed to fetch news"));
      setNews([]);
    } finally {
      setLoading(false);
    }
  }, [areaOfInterestId, limit, offset]);

  useEffect(() => {
    fetchNews().catch(() => undefined);
  }, [fetchNews]);

  return {
    news,
    loading,
    error,
    refetch: fetchNews,
  };
}

